import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { DashSidebar } from './DashSidebar';
import { DashTopbar } from './DashTopbar';

export const DashShell: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <div className={`dash-shell ${mobileOpen ? 'is-mobile-open' : ''}`}>
      <DashSidebar />
      {mobileOpen && (
        <div
          className="dash-overlay"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}
      <div className="dash-main">
        <DashTopbar mobileOpen={mobileOpen} onMenuToggle={() => setMobileOpen((v) => !v)} />
        <div className="dash-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashShell;
